import { useIntlTokens } from "@/src/components/mobile/useIntlTokens";
import {
  TitleInput,
  RichDescriptionInputText,
} from "@/src/components/RichDescriptionInput";
import { AHSeparator } from "arkh";
import { TodoEditNewMainCreationInfo } from "arkh/src/cross-platform/Todo/TodoEditNewMainCreationInfo";
import { useFragment } from "react-relay";
import { graphql } from "relay-runtime";
import { TodoEditNewMainStoreTitleAndDescription_todo$key } from "./__generated__/TodoEditNewMainStoreTitleAndDescription_todo.graphql";
import { useTodoEditSetBody } from "./todoMutationHooks/useTodoEditSetBody";
import { useTodoEditSetTitle } from "./todoMutationHooks/useTodoEditSetTitle";

export function TodoEditNewMainStoreTitleAndDescription(props: {
  TitleComponent?: React.ReactNode;
  todo: TodoEditNewMainStoreTitleAndDescription_todo$key;

  setStatus: (key: string, status: "saving" | "saved" | "error") => void;
}) {
  const todo = useFragment(
    graphql`
      fragment TodoEditNewMainStoreTitleAndDescription_todo on Todo {
        id
        ...TodoEditNewMainCreationInfo

        title
        body
        canWrite
        isIssue
      }
    `,
    props.todo
  );
  const issuePlaceholder = todo.isIssue && todo.title === "";
  const intl_tokens = useIntlTokens();
  const readOnly = !todo.canWrite;

  const [title, setTitle] = useTodoEditSetTitle(
    todo.id,
    todo.title,
    props.setStatus
  );
  const [body, setBody] = useTodoEditSetBody(
    todo.id,
    todo.body ?? "",
    props.setStatus
  );

  return (
    <>
      {props.TitleComponent ?? (
        <>
          <TodoEditNewMainCreationInfo todo={todo} />

          <TitleInput
            placeholder={issuePlaceholder ? intl_tokens.Issue : undefined}
            title={title}
            setTitle={setTitle}
            disabled={readOnly}
          />
        </>
      )}
      <AHSeparator />
      <RichDescriptionInputText
        description={body}
        setDescription={setBody}
        readOnly={readOnly}
      />
    </>
  );
}
